module.exports = __webpack_public_path__ + "static/media/Lato-Bold.4035399d.ttf";